import {useQuery} from '@tanstack/react-query'
import api from "../../api/api";
import {AxiosError} from "axios";
import Typecheck from "../../../utils/Typecheck";
import {isConstructorModel} from "../../types/ConstructorModel";

const modelsEndpoint = '/builder/models';

export const useGetConstructorModels = () => {
    return useQuery(
        [modelsEndpoint],
        () => api.get(modelsEndpoint).then((response: unknown) => {

            if (!response || !Typecheck.isArrayOf(response, isConstructorModel)) {
                throw new AxiosError('Models Request have wrong response', 'WRONG_RESPONSE_MODELS');
            }

            if (!response.length) {
                throw new AxiosError('Models Request have empty response', 'EMPTY_RESPONSE_MODELS');
            }

            return response;
        }).catch(err => {
            throw err;
        }),
        {
            select: (response) => response || [],
        }
    );
};
